export default __webpack_public_path__ + "static/media/edit-outline-16px.9452dbe0.svg";